// src/components/PasswordRotationBanner.js
// S4c ítem 3 — banner bilingüe (ES + EN a la vez: no hay switch de idioma aún)
// que vive mientras users/{uid}.passwordRotation.requiredAt > passwordChangedAt.
// El doc del usuario se carga UNA vez al iniciar sesión (App.js), así que el
// banner solo desaparece tras cambiar la contraseña y volver a entrar: ese es el
// comportamiento pedido ("persistente hasta re-login").
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { needsPasswordRotation } from '../lib/passwordPolicy';
import { tIn } from '../lib/i18n';

const PasswordRotationBanner = ({ user }) => {
    const navigate = useNavigate();
    const location = useLocation();
    if (!needsPasswordRotation(user)) return null;
    const enProfile = location.pathname.startsWith('/profile');
    return (
        <div role="alert" className="bg-amber-100 border-b-2 border-amber-400 text-amber-900 px-4 py-2 text-sm flex flex-col md:flex-row md:items-center gap-2">
            <div className="flex-1 min-w-0">
                <p><strong>{tIn('es', 'password.banner.title')}.</strong> {tIn('es', 'password.banner.body')}</p>
                <p className="text-amber-800/80"><strong>{tIn('en', 'password.banner.title')}.</strong> {tIn('en', 'password.banner.body')}</p>
            </div>
            {!enProfile && (
                <button
                    type="button"
                    onClick={() => navigate('/profile#password')}
                    className="flex-shrink-0 px-3 py-1.5 rounded-md bg-amber-600 text-white font-semibold hover:bg-amber-700"
                >
                    {tIn('es', 'password.banner.cta')} · {tIn('en', 'password.banner.cta')}
                </button>
            )}
        </div>
    );
};

export default PasswordRotationBanner;
